import {
    nxv1270a,
    nsv106,
    ntc2000lsy,
    virtual,
    nfx400a,
    uv650,
    digital,
    video
} from "./imgIconConfig.js"

const emoConfig = [
    {top:'45%', left:'23%',src:nxv1270a,card:['machine','NXV1270A']},   
    {top:'40%', left:'41%',src:nsv106,card:['machine','NSV106AS']},   
    {top:'54%', left:'42%',src:ntc2000lsy,card:['machine','NTC2000LSY']},  
    {top:'66%', left:'57%',src:virtual},   
    {top:'58%', left:'15%',src:nfx400a,card:['machine','NFX400AMPS']},  
    {top:'62%', left:'43%',src:uv650,card:['machine','UV650']},   
    {top:'57%', left:'76%',src:digital,card:['smartManufacturing', 'SMObjectives']},  
    {top:'80%', left:'90%',src:video},   
]


export {emoConfig}